import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const cache = {};
const listeners = {};

const fetchKey = async (key) => {
  if (cache[key] !== undefined) return cache[key];
  try {
    const { data } = await api.get(`/site-content/${key}`);
    cache[key] = data?.content || {};
  } catch (e) {
    cache[key] = {};
  }
  (listeners[key] || []).forEach((fn) => fn(cache[key]));
  return cache[key];
};

export function useSiteContent(key, fallback = {}) {
  const [content, setContent] = useState(cache[key] || null);
  useEffect(() => {
    let mounted = true;
    if (!listeners[key]) listeners[key] = [];
    const cb = (c) => { if (mounted) setContent(c); };
    listeners[key].push(cb);
    fetchKey(key);
    return () => {
      mounted = false;
      listeners[key] = (listeners[key] || []).filter((f) => f !== cb);
    };
  }, [key]);
  const c = content || cache[key] || {};
  return { ...fallback, ...c };
}
